import React, { useEffect, useState } from "react";
import SC from "./style";
import {
  Breadcrumbs,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
} from "InnoUI/components";
import { useLocation, useNavigate } from "react-router";
import { Switch } from "antd";
import theme from "theme";
import { apiGet, apiPost } from "api/callApi";
import { ImagePreview, MoveOccupant } from "components";
import OccupantTab from "./OccupantTab";
import FolderProjectStructure from "../FolderProjectStructure";
import { projectType } from "utils/lookUpTable";
import { showAlert } from "utils/helper";
import ExportPropertyModal from "components/ExportPropertyModal";
import DeleteComponent from "views/AdminSettings/DeleteComponent";
import { InnoTableDefaultPageSize } from "utils/config";

const Occupant = ({ popupState }) => {
  const location = useLocation();
  const { rowAllData, data } = location.state || {};

  const [occupant, setOccupant] = useState([]);
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [rowData, setRowData] = useState();
  const [rowId, setRowId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openFolderStructure, setopenFolderStructure] = useState(false);
  const [openModalView, setOpenModalView] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [fieldId, setFieldId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const navigate = useNavigate();

  const levelname = rowAllData ? rowAllData.name : "Default Name";

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Projects", href: "/admin-settings/projects" },
    {
      label: `${data?.propertyName || ""}`,
      href: "/admin-settings/projects/level",
    },
    {
      label: `${rowAllData?.name || ""}`,
    },
  ];

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href, { state: { data } });
    }
  };

  const getAllOccupant = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet(`/v1/occupant/${rowAllData.id}`, false);
      setOccupant(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAllOccupant();
  }, []);

  const handleChange = async (id, property, value) => {
    try {
      const endpoint = `/v1/editoccupant/${id}`;
      const response = await apiPost(endpoint, { [property]: value });
      setOccupant((prevProjects) =>
        prevProjects.map((project) =>
          project.id === id ? { ...project, [property]: value } : project,
        ),
      );
      showAlert({ title: "Success", text: response.message, icon: "success" });
    } catch (error) {
      console.error("Error updating status:", error);
      showAlert({
        title: "Error",
        text: "Failed to update status",
        icon: "error",
      });
    }
  };

  const closeDrawer = () => {
    setOpen(false);
    setIsEditing(false);
  };

  const onAddDataCallback = () => {
    setOpen(true);
    setRowData("");
    setIsEditing(false);
  };

  const onRowClick = (data) => {
    setIsEditing(true);
    setRowData(data);
    setOpen(true);
    setRowId(data.id);
  };

  const closeFolderStructure = () => {
    setopenFolderStructure(false);
    setRowData(null);
  };
  const handleExportClick = async (record) => {
    // navigate(`/downloadproject?projectId=${record.id}&type=${1}`);
    window.open(`/downloadproject?projectId=${record.id}&type=${1}`, "_blank");
  };

  const handleProjectStructure = (record) => {
    setopenFolderStructure(true);
    setRowData(record);
  };

  const handleMove = (record) => {
    console.log(record, "recordrecordrecord");

    setRowId(record.id);
    setOpenModalView(true);
    setRowData(record);
  };

  const handleOpenModal = (record) => {
    setOpenModal(true);
    setRowData(record);
  };

  const handleDeleteOpenModal = (record) => {
    setFieldId(record?.id);
    setRowData(record);
    setOpenDeleteView(true);
  };

  const handleDelete = async (occupantId) => {
    try {
      const body = {
        projectId: occupantId,
        projectType: projectType.occupant,
      };
      const response = await apiPost(`/v1/deleterequest`, body, false);
      showAlert({ title: "Success", text: response.message, icon: "success" });
      getAllOccupant();
      setOpenDeleteView(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 80,
      render(value, record, index) {
        // const pageSize = innoTableConfigsecond.pageSize;
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },
    {
      title: "Occupant No.",
      dataIndex: "occupantNo",
      // sorter: (a, b) => a.occupantNo.localeCompare(b.occupantNo),
      // showSorterTooltip: { target: "sorter-icon" },
      // sortDirections: ["ascend", "descend"],
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>{value}</SC.ValueSpan>
          </>
        );
      },
    },

    {
      title: "Occupant Name",
      dataIndex: "occupantName",
      sorter: (a, b) => a.occupantName.localeCompare(b.occupantName),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "350px" },
      }),
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Edit",
            onClick: () => onRowClick(record),
          },
          {
            id: 2,
            text: "Manage Folder Structure",
            onClick: () => handleProjectStructure(record),
          },
          {
            id: 3,
            text: "Move",
            onClick: () => handleMove(record),
          },
          {
            id: 4,
            text: "Export",
            onClick: (event) => {
              event.stopPropagation();
              handleOpenModal(record);
            },
          },
          {
            id: 5,
            text: "Delete",
            onClick: (event) => {
              event.stopPropagation();
              handleDeleteOpenModal(record);
            },
          },
        ];
        return (
          <SC.PopoverContainer>
            <SC.ValueSpan>{value}</SC.ValueSpan>
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <>
                    <div
                      style={{
                        width: "50px",
                        textAlign: "center",
                        justifyContent: "end",
                        display: "flex",
                        marginRight: "5px",
                      }}
                    >
                      <SC.PopoverSpan>
                        <SC.MoreVertIcon />
                      </SC.PopoverSpan>
                    </div>
                  </>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid ${theme.colors.bordertask}`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },

    {
      title: "Folder Template",
      dataIndex: "templateName",
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>{value}</SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Images",
      dataIndex: "occupantGraphic",
      render(value, record, index) {
        return (
          <>
            <ImagePreview width={40} src={`${value}`} />
          </>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>{value}</SC.ValueSpan>
          </>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (value, record) => (
        <Switch
          checked={value}
          onChange={(checked) =>
            handleChange(record.id, "status", checked ? 1 : 0)
          }
          style={{
            transform: "scale(0.7)",
            backgroundColor: value ? `${theme.colors.themeColor}` : undefined,
            borderColor: value ? `${theme.colors.themeColor}` : undefined,
          }}
        />
      ),
    },
  ];

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: true,
    search: true,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      // showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    action: false,
    divBorder: true,
    sno: false,
    searchPlaceholder: "Search by Name, Number and Template",
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={location.pathname}
        onClick={handleBreadcrumbClick}
      />

      <SC.BodyContainer>
        <div
          style={{
            width: "450px",
            height: "100px",
            borderRadius: "8px",
            overflow: "hidden",
            margin: "60px 20px 10px 25px",
            border: `3px solid ${theme.colors.greyColor}`,
          }}
        >
          <ImagePreview
            src={rowAllData?.image}
            height={"100%"}
            width={"100%"}
            style={{ objectFit: "contain" }}
          />
        </div>

        <SC.Container>
          <InnoTable
            tableConfig={tableConfig}
            padding="4px 8px"
            column={subColumnData}
            data={occupant}
            tableKey="Occupant"
            ComponnentName={levelname}
            searchKeys={["occupantNo", "occupantName", "templateName"]}
            onRowClickCallback={onRowClick}
            onAddDataCallback={onAddDataCallback}
            loading={isLoading}
          />
        </SC.Container>
      </SC.BodyContainer>
      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"700px"}
          children={
            <OccupantTab
              occupantdata={rowData}
              levelId={rowAllData.id}
              Projectdata={data}
              onClose={closeDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              fetchData={getAllOccupant}
              rowId={rowId}
              isInfo={false}
              setOccupant={setOccupant}
            />
          }
        />
      )}

      {openFolderStructure && (
        <DetailDrawer
          open={openFolderStructure}
          onClose={closeFolderStructure}
          closable={true}
          width={"70%"}
          children={
            <FolderProjectStructure
              onClose={closeFolderStructure}
              rowData={rowData}
              projectType={projectType.occupant}
            />
          }
        />
      )}
      {openModalView && (
        <MoveOccupant
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          occupantData={rowData}
          fetchData={getAllOccupant}
        />
      )}

      {openModal && (
        <ExportPropertyModal
          setOpenModal={setOpenModal}
          openModal={openModal}
          rowData={rowData}
          projectType={1}
        />
      )}

      {openDeleteView && (
        <DeleteComponent
          title={"Delete User"}
          messageData={`Are you sure you want to delete user ${
            rowData?.propertyName || ""
          }?`}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => handleDelete(fieldId)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
        />
      )}
    </>
  );
};

export default Occupant;
